import { Filters, Travelers } from './search-body.model';
import Itinerary from './itinerary.model';
import CurrencyList from './currency-list.model';

export default class SearchResults {
    public search: Search;
    public solutions: SolutionsInfo;
    public more_options: Array<Array<MoreOptions>>;
    public results: Results;

    constructor() {
        this.search = {
            AirQuoteID: '',
            fares: [],
            filter: 1,
            itinerary_id: '',
            price: {
                taxes: '',
                total: ''
            },
            price_luggage: {
                taxes: '',
                total: ''
            },
            prices: {
                adt: 1,
                chd: null,
                inf: null
            },
            prices_luggage: {
                adt: 1,
                chd: null,
                inf: null
            }
        }
        this.solutions = {
            created_at: '',
            currency: '',
            filters: {
                airport_change: true,
                alliance: [],
                cabin: '',
                cluster: true,
                flexible_dates: true,
                hub: true,
                include_nearby: true,
                round_trip: true
            },
            include_alternative_packages_solutions: 0,
            include_kiwi: 0,
            itinerary: [],
            itinerary_id: 0,
            package_prices_stats: {
                lowest_customize: {
                    cost: '',
                    result_id: 0
                },
                lowest_packages: {
                    cost: '',
                    result_id: 0
                }
            },
            route: '',
            solutions: [],
            travelers: {
                A: 1,
                C: 0,
                I: 0,
            },
            xchange: {
                currencyList: []
            }
        }
        this.more_options = [[]]
        this.results = {
            price: {
                total: 0,
                taxes: 0
            },
            price_luggage: {
                total: 0,
                taxes: 0
            },
            prices: {
                adt: 0,
                chd: 0,
                inf: 0
            },
            prices_luggage: {
                adt: 0,
                chd: 0,
                inf: 0
            },
            fares: [],
            segments_normalized: [],
            AirQuoteId: '',
            itinerary_id: 0,
            filter: 0,
            result_id: 0
        }
    }
}

interface Search {
    AirQuoteID: string,
    fares: Array<Fare>,
    filter: number,
    itinerary_id: string,
    price: {
        taxes: string,
        total: string
    },
    price_luggage: {
        taxes: string,
        total: string
    },
    prices: {
        adt: number,
        chd: number | null,
        inf: number | null
    },
    prices_luggage: {
        adt: number,
        chd: number | null,
        inf: number | null
    }
}

interface SolutionsInfo {
    created_at: string,
    currency: string,
    filters: Filters,
    include_alternative_packages_solutions: number,
    include_kiwi: number,
    itinerary: Array<Itinerary>,
    itinerary_id: number,
    package_prices_stats: {
        lowest_customize: {
            cost: string,
            result_id: number
        },
        lowest_packages: {
            cost: string,
            result_id: number
        }
    },
    route: string,
    solutions: Array<Solution>,
    travelers: Travelers,
    xchange: CurrencyList
}

interface Solution {
    result_id: number,
    filter_by: number,
    price: number,
    is_top: boolean
}

interface MoreOptions {
    airquote_id: string,
    arrival: {
        airport: string,
        date: string,
        desc: string,
        parent_city_code: string,
        terminal: string,
        time: string,
        timestamp: number
    },
    chunk_id: number,
    company: string,
    consolidator: string,
    cost: {
        base: number,
        luggage_fee: number,
        luggage_total: number,
        taxes: number,
        total: number,
        types: Array<FareCostPriceType>
    },
    departure: {
        airport: string,
        date: string,
        desc: string,
        parent_city_code: string,
        terminal: string,
        time: string,
        timestamp: number
    },
    duration: number,
    fare_id: number,
    group_id: number,
    price: {
        base: number,
        cc: number,
        fee: number,
        taxes: number,
        total: number,
        types: Array<FarePriceType>
    },
    price_luggage: {
        base: number,
        cc: number,
        fee: number,
        taxes: number,
        total: number,
        types: Array<FarePriceType>
    },
    route_hack_type: number,
    segments: Array<Segment>,
    session_id: number,
    stops: number,
    type: number
}

interface Results {
    price: {
        total: number,
        taxes: number
    },
    price_luggage: {
        total: number,
        taxes: number
    },
    prices: {
        adt: number,
        chd: number,
        inf: number
    },
    prices_luggage: {
        adt: number,
        chd: number,
        inf: number
    },
    fares: Array<Fare>,
    segments_normalized: Array<any>
    AirQuoteId: string,
    itinerary_id: number,
    filter: number,
    result_id: number
}

interface Fare {
    segments: Array<Segment>,
    cost: FareCost,
    duration: number,
    stops: number,
    group_id: number,
    company: string,
    price: {
        types: Array<FarePriceType>,
        fee: number,
        total: number,
        taxes: number,
        base: number,
        cc: number,
    },
    price_luggage: {
        types: Array<FarePriceType>,
        fee: number,
        total: number,
        taxes: number,
        base: number,
        cc: number
    },
    session_id: string,
    airquote_id: string,
    consolidator: string,
    departure: FareStopDeparture,
    arrival: FareStopArrival,
    route_hack_type: number,
    chunk_id: number,
    fallback: boolean,
    fare_id: number,
    type: number
}

export interface Segment {
    stops: Array<FareStop>,
    duration: number,
    airline: string,
    cabin: string,
    departure: FareSegmentDeparture,
    arrival: FareSegmentArrival,
    airline_name: string,
    airline_image: string
}

interface FareStop {
    departure: FareStopDeparture,
    arrival: FareStopArrival,
    number: number,
    equipment: string,
    airline: string,
    operated_by: string,
    tech_stops: Array<any>,
    duration: number,
    cabin: string,
    booking_class: string,
    fare_type: string,
    airport_change: boolean,
    airline_name: string,
    operated_by_name: string,
    flight_time: number,
    layover_time: number,
    bags_recheck_required: number,
    airline_image: string
}

interface FareSegmentDeparture {
    date: string,
    time: string,
    airport: string,
    terminal: string,
    idx: number,
    timestamp: number,
    desc: string,
    flags: FareSegmentFlags,
    parent_city_code: string
}

interface FareSegmentFlags {
    nearby: boolean,
    taxi: boolean,
    shuttle: boolean,
    hub: boolean,
    flex: boolean,
    type: number
}

interface FareSegmentArrival {
    date: string,
    time: string,
    airport: string,
    terminal: string,
    idx: number,
    timestamp: number,
    desc: string,
    flags: FareSegmentFlags,
    parent_city_code: string
}

interface FareCost {
    total: number,
    luggage_fee: number,
    luggage_total: number,
    taxes: number,
    base: number,
    types: Array<FareCostPriceType>
}

export interface FarePriceType {
    category: 'ADT' | 'CHD' | 'INF',
    fee: number,
    total: number,
    taxes: number,
    base: number,
    cc: number
}

export interface FareCostPriceType {
    category: 'ADT' | 'CHD' | 'INF',
    total: number,
    taxes: number,
    base: number,
    luggage_fee: number,
    luggage_total: number
}

interface FareStopDeparture {
    date: string,
    time: string,
    airport: string,
    terminal: string,
    timestamp: number,
    desc: string,
    parent_city_code: string
}

interface FareStopArrival {
    date: string,
    time: string,
    airport: string,
    terminal: string,
    timestamp: number,
    desc: string,
    parent_city_code: string
}